import { render, staticRenderFns } from "./ConsularGratisVisa.vue?vue&type=template&id=5a0b0408&class=pa-0&"
import script from "./ConsularGratisVisa.vue?vue&type=script&lang=js&"
export * from "./ConsularGratisVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports